module.exports = __webpack_public_path__ + "static/media/progress.1bf216aa.svg";